export const GET_ADMISSION_REPORT_FILTERS = 'GET_ADMISSION_REPORT_FILTERS'
export const GET_ADMISSION_REPORT_SUMMARY = 'GET_ADMISSION_REPORT_SUMMARY'
export const GET_ADMISSION_REPORT_APPLICANTS = 'GET_ADMISSION_REPORT_APPLICANTS'
export const CHANGE_ADMISSION_STATUS = 'CHANGE_ADMISSION_STATUS'
export const CHANGE_ADMISSION_STATUS_BULK = 'CHANGE_ADMISSION_STATUS_BULK'
export const PREVIEW_ADMISSION_LETTER = 'PREVIEW_ADMISSION_LETTER'
